import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useSelector } from 'react-redux'
import style from './CreateWarehouseAccountView.module.css';
import { Translate } from "../../../../language";
import { UploadImage } from "../../../../components/Register/UploadFile";
import Input from "../../../../utils/components/Input/Input";
import Button from "../../../../utils/components/Button/Button";
import { usePlaces } from "../../../../utils/hooks/usePlaces";
import useModal from "../../../../utils/hooks/useModal";
import Swal from "sweetalert2";
import TitleSVG from "../../../../utils/components/TitleSVG/TitleSVG";
import { OwnWarehouseIcon } from "../../../../assets/icons";

export default function UpdateWarehouseAccountView({ formik, isEdit = false ,wareHouse    }) {

  const { countries, states, cities } = usePlaces(formik.values.businessCountry, formik.values.businessDepartment)
  const [picture, setPicture] = useState(wareHouse?.picture?.url?.origin);
  const [ref, isShowModal, setIsShowModal] = useModal(false);
  useEffect(() => {
    setPicture(wareHouse?.profileId?.picture?.url?.origin)
  }, [wareHouse])


  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
  })

  const Modal = ({ presentation, displayModal, close, name }) => {
    const updateWarehouse = () => {
      formik.handleSubmit();
      close();
    }

    const divStyle = displayModal ? `${style.display_modal}` : `${style.display_modal_none}`

    if (!presentation) {
      return <></>
    }
    return (

      <div className={`${divStyle}`} >
        <div className={style.register_modal}>
          <p className={style.textRegisterModal}>  ¿Desea {isEdit ? "editar" : "registrar"} el usuario {name}? </p>

          <div className={`${style.button_modal_container}`}>
            <Button styles={{ width: "50%" }} onClick={() => { updateWarehouse() }} text='Si' />
            <Button styles={{ width: "50%" }} onClick={() => { close() }} text='No' />
          </div>
        </div>
      </div>
    )
  }

  const onClickRegisterButton = () => {
  
    formik.validateForm().then((errors) => {
      if (Object.keys(errors).length > 0) {
        Toast.fire({
          icon: 'error',
          title: 'Faltan campos requeridos por llenar'
        })
      }
      else {
        setIsShowModal(true);
      }
    })
  }

  return (
    <div>
      <TitleSVG Icon={OwnWarehouseIcon} titleHighlight={Translate('update', 'es')} title={Translate('updateWareHouseTitle', 'es')} />
      {/*TodoVictor: Incluir UploadImage una vez corregido el servicio */}
      <div className={`row centerItems`}>
         <UploadImage
          isUpdate={true}
          classNameUpload={style.upload_image}
          picture={picture}
          setPicture={setPicture}
          setFile={(value) => { formik.setFieldValue("picture", value) }}
        /> 
      </div>

      <div className={style.form_container}>
        <div className={`text-error-input`}>{formik.errors.picture}</div>
      </div>

      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="name"
          type="text"
          placeholder={'Nombre'}
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.errors.name}
        />

        <Input
          classNameInput={style.input_form}
          name="phone"
          type="text"
          placeholder={'Teléfono'}
          value={formik.values.phone}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.phone}
        />

      </div>


      <div className={style.form_container}>


        {
          !isEdit && <Input
            classNameInput={style.input_form}
            name="email"
            type="email"
            placeholder={'Correo'}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.email}
          />
        }
        {
          !isEdit && <>
            <Input
              classNameInput={style.input_form}
              name="password"
              type="password"
              placeholder={'Contraseña'}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.password}
            />
            <Input
              classNameInput={style.input_form}
              name="passwordConfirm"
              type="password"
              placeholder={'Confirme la contraseña'}
              value={formik.values.passwordConfirm}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.passwordConfirm}
            />
          </>
        }

      </div>
      <div className={style.form_container}>
        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="businessCountry"
            value={formik.values.businessCountry}
            onChange={formik.handleChange}
            error={formik.errors.businessCountry}>
            <option value="">País</option>
            {countries.map((country) => (
              <option key={country.countryID} value={country.countryName}>
                {country.countryName}
              </option>
            )
            )}
          </select>
          <div className={`text-error-input`}>{formik.errors.businessCountry}</div>
        </div>

        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="businessDepartment"
            value={formik.values.businessDepartment}
            onChange={formik.handleChange}
            error={formik.errors.businessDepartment}>

            <option value="">Departamento</option>
            {states.map((state) => (
              <option key={state.stateID} value={state.stateName}>
                {state.stateName}
              </option>
            )
            )}
          </select>
          <div className={`text-error-input`}>{formik.errors.businessDepartment}</div>

        </div>

        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="businessCity" value={formik.values.businessCity}
            onChange={formik.handleChange}
          >
            <option value="">Ciudad</option>
            {cities.map((city) => (
              <option key={city.cityID} value={city.cityName}>
                {city.cityName}
              </option>
            )
            )}
          </select>
          <div className={`text-error-input`}>{formik.errors.businessCity}</div>

        </div>
      </div>
      <div className={style.form_container}>

        <Input
          classNameInput={style.input_form}
          name="neighborhood"
          type="text"
          placeholder={'*Barrio'}
          value={formik.values.neighborhood}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.neighborhood}
        />

        <Input
          classNameInput={style.input_form}
          name="businessAddress"
          type="text"
          placeholder={'*Dirección'}
          value={formik.values.businessAddress}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.businessAddress}
        />

      </div>
      <div className={style.form_container}>

        <Button type="submit" onClick={() => { onClickRegisterButton() }} classNameContent={"button-save-verify-account"} text={Translate('send', 'es')} theme="white" />
      </div>
      <Modal
        presentation={{}}
        displayModal={isShowModal}
        close={() => setIsShowModal(false)}
        name={formik.values.name}
      />
    </div >
  );
}
